<template>
  <td :rowspan="rows" class="calc-block-cell" :class="'calc-block-cell--' + block" :title="compact ? title : ''">
    <b>{{ block.toUpperCase() }}</b>
    <span v-if="!compact" class="calc-block-cell__name">{{ name }}</span>
  </td>
</template>

<script>
/**
 * Erste Spalte eines Kostenblocks der Kalkulation (Karte "Angebote - Update - Teil 2", Punkt 12.a):
 * A Wareneingang, B Logistik, C Gemeinkosten, D Vertriebskosten. Die Zeilen des Blocks bekommen die Klassen
 * "calc-row calc-row--<block>" (Summenzeilen zusaetzlich "calc-sum") und werden dadurch passend eingefaerbt.
 */
export default {
  name: "CalcBlockCell",
  props: {
    block: { type: String, required: true, validator: (v) => ["a", "b", "c", "d"].includes(v) },
    rows: { type: Number, required: true },
    compact: { type: Boolean, default: false },
  },
  computed: {
    name() {
      return this.$t("calcLabels.block." + this.block);
    },
    title() {
      return `${this.$t("calcLabels.block.title")} ${this.block.toUpperCase()}: ${this.name}`;
    },
  },
};
</script>

<style>
.calc-block-cell {
  width: 1%;
  min-width: 26px;
  padding: 6px 8px !important;
  vertical-align: top !important;
  white-space: nowrap;
  font-size: 12px;
  color: #333;
  border-bottom: 2px solid #fff !important;
}
.calc-block-cell__name {
  display: block;
  font-size: 11px;
}
.calc-block-cell--a {
  background: #f2cef0 !important;
}
.calc-block-cell--b {
  background: #c5e9f9 !important;
}
.calc-block-cell--c {
  background: #f0a982 !important;
}
.calc-block-cell--d {
  background: #f3e3a1 !important;
}
.calc-row.calc-row--a > td {
  background: #fcf1fb;
}
.calc-row.calc-row--b > td {
  background: #eef8fd;
}
.calc-row.calc-row--c > td {
  background: #fbe5d9;
}
.calc-row.calc-row--d > td {
  background: #fdf8e6;
}
.calc-row.calc-row--a.calc-sum > td {
  background: #f6ddf4;
}
.calc-row.calc-row--b.calc-sum > td {
  background: #d9f0fb;
}
.calc-row.calc-row--c.calc-sum > td {
  background: #f5c9b0;
}
.calc-row.calc-row--d.calc-sum > td {
  background: #f8eec4;
}
.calc-row.calc-row--a.calc-head > td {
  background: #f6ddf4;
}
</style>
